/**
 * fieldConfig — frontend mirror of backend sp_agent_registry DRAFT_FIELDS.
 *
 * Single source of truth for which fields use the draft layer
 * and human-readable labels.
 */

/** Fields that use the versioned draft layer (propose_edit semantics). */
export const DRAFT_FIELDS = new Set([
  'state_of_the_art',
  'solution_description',
  'fto_analysis',
  'patentability',
  'patent_application',
]);

/** Fields that use direct edit (immediate overwrite, no draft). */
export const DIRECT_EDIT_FIELDS = new Set([
  'problem_statement',
  'claims',
]);

/** Fields that support image insertion in the rich-text editor. */
export const FIELDS_WITH_IMAGES = new Set([
  'solution_description',
  'patent_application',
]);

/**
 * Workspace field -> relevance context_field of the document_relevance store.
 * Mirrors backend RELEVANCE_CONTEXT_FIELDS (models/document_relevance.py).
 * claims and problem_statement workspaces show solution prior art -> our_solution.
 */
export const FIELD_TO_RELEVANCE_CONTEXT: Record<string, string> = {
  state_of_the_art: 'state_of_the_art',
  problem_statement: 'state_of_the_art',
  solution_description: 'our_solution',
  claims: 'our_solution',
  fto_analysis: 'fto',
  patentability: 'patentability',
  patent_application: 'patent_application',
  industrialization: 'industrialization',
};

/** Human-readable labels (fallback — prefer i18n keys). */
export const FIELD_LABELS: Record<string, string> = {
  problem_statement: 'Problem Statement',
  state_of_the_art: 'State of the Art',
  solution_description: 'Solution Description',
  claims: 'Claims',
  fto_analysis: 'Freedom to Operate',
  patentability: 'Patentability',
  patent_application: 'Patent Application',
  industrialization: 'Industrialization',
};
